<template>
  <div
    v-if="!isConsentCookieSet"
    class="cookie-consent fixed w-full bg-primary-delta py-12 bottom-0 z-50"
  >
    <div class="body relative w-full mx-auto container px-5 md:px-4">
      <h4
        v-if="i18n.title"
        class="text-lg mb-4"
      >
        {{ i18n.title }}
      </h4>
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="text text-sm"
        v-html="i18n.text"
      />
      <!-- eslint-enable vue/no-v-html -->
      <div class="options">
        <kf-button
          class="btn"
          type="secondary"
          :disabled="false"
          @click.prevent="setConsent(true)"
        >
          {{ i18n.labelAccept }}
        </kf-button>
        <a
          href="#"
          class="link text-base"
          @click.prevent="setConsent(false)"
        >{{ i18n.labelDecline }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
const cookieName = 'cookie_consent';
const partouCookie = 'PartouCookieAccepted';

export default {
  name: 'KfCookieConsent',
  components: {
    KfButton: () => import(/* webpackChunkName: "main" */ '@/components/base/button/Button.vue'),
  },
  props: {
    i18n: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState({
      isConsentCookieSet: (state) => state.cookies.isConsentCookieSet,
      isConsentGiven: (state) => state.cookies.isConsentGiven,
    }),
  },
  watch: {
    isConsentGiven(current) {
      if (current) {
        const cookie = this.$cookies.get(cookieName);
        this.setGTM(cookie);
      }
    },
  },
  beforeMount() {
    const cookie = this.$cookies.get(cookieName);

    if (cookie) {
      this.$store.commit('cookies/updateConsentGiven', cookie.level);
    }
  },
  methods: {
    setConsent(value) {
      const whyPlanConsent = value ? 'AcceptAll' : 'OnlyFunctional';

      this.$cookies.set(cookieName, {level: value}, '1y')
      this.$cookies.set(partouCookie, whyPlanConsent, '1y')

      this.$store.commit('cookies/updateConsentGiven', value);
    },
    setGTM(enabled) {
      this.$gtm.enable(enabled);
    },
  },
};
</script>

<style lang="postcss">
.cookie-consent {

  .body {

    a {
      @apply text-black underline;

      &:hover {
        @apply no-underline;
      }
    }

    .options {
      @apply mt-8;

      .btn,
      .link {
        @apply no-underline block;
      }

      .btn {
        @apply mr-8 px-6 py-3 mb-8 md:mb-0 w-full;
        min-width: 335px;

        @screen md {
          @apply w-auto inline-block;
        }
      }

      .link {
        @apply underline;

        &:hover {
          @apply underline;
        }

        @screen md {
          @apply w-auto inline-block;
        }
      }
    }
  }
}
</style>
